import { RegularExpressions } from "../../helpers/constants";
import { systemLogFilterMessages } from "../../helpers/messages";

/**
 * @description Function for validate each input field
 * @param stateObj Current state object
 * @returns Object with error messages
 */
export const validateSearchFields = (stateObj, fields = ['region', 'searchBy', 'searchString']) => {
    var { errors, editObj } = stateObj;
    var errorFlag = false;
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const reWhiteSpace = new RegExp(/^\s+$/);
        if (!editObj[field] || reWhiteSpace.test(editObj[field]) === true || (Array.isArray(editObj[field]) && editObj[field].length < 1)) {
            errorFlag = true;
            errors[field] = systemLogFilterMessages[field];
        }
    }

    return { errorFlag, errors };
}

/**
 * @description function for validate alphanumeric keyword
 * @param value Keyword field
 * @returns Object with error messages
 */
export const validateKeyword = (value) => {
    var errorFlag = !RegularExpressions.systemLogKeyword.test(value);
    return { errorFlag: errorFlag ? true : false, error: errorFlag ? systemLogFilterMessages.searchString : '' }
}